'use client';

import { useState } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './components/HeroSection';
import TrustSignals from './components/TrustSignals';
import FeaturedCourses from './components/FeaturedCourses';
import WhyChooseUs from './components/WhyChooseUs';
import SuccessStories from './components/SuccessStories';

import CTASection from './components/CTASection';
import Footer from './components/Footer';

export default function Homepage() {
  const [bgColor, setBgColor] = useState('#28afbb');

  // Function to get contrasting text color
  const getContrastColor = (hexColor: string) => {
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? '#000000' : '#ffffff';
  };

  const textColor = getContrastColor(bgColor);

  return (
    <div className="min-h-screen" style={{ backgroundColor: bgColor, color: textColor }}>
      <Header />
      
      {/* remove Color Picker Control div */}

      <main className="pt-16">
        <HeroSection textColor={textColor} />
        <TrustSignals textColor={textColor} />
        <FeaturedCourses textColor={textColor} />
        <WhyChooseUs textColor={textColor} />
        <SuccessStories textColor={textColor} />
        <CTASection textColor={textColor} />
      </main>

      <Footer />
    </div>
  );
}